// extracted by mini-css-extract-plugin
export default {"ul":"scrollbar_ul__m-sb-","li":"scrollbar_li__J83ey","li_active":"scrollbar_li_active__lB6i5","button":"scrollbar_button__ybjbw"};